import { createContext, useContext, ReactNode } from 'react';
import { SubscriptionOverview } from '../data';

interface SubscriptionOverviewContextValue {
  subscriptionOverviewData: SubscriptionOverview | null | undefined;
  handleSubscriptionOverviewRequest: any;
}

const SubscriptionOverviewContext = createContext<SubscriptionOverviewContextValue | undefined>(undefined);

interface SubscriptionOverviewProviderProps {
  children: ReactNode;
  value: SubscriptionOverviewContextValue;
}

export const SubscriptionOverviewProvider = ({ children, value }: SubscriptionOverviewProviderProps) => {
  return (
    <SubscriptionOverviewContext.Provider value={value}>
      {children}
    </SubscriptionOverviewContext.Provider>
  );
};

export const useSubscriptionOverview = () => {
  const context = useContext(SubscriptionOverviewContext);
  if (context === undefined) {
    console.error('useSubscriptionOverview must be used within a SubscriptionOverviewProvider');
  }
  return context;
};
